var map = {
	"./1/tab-banner1.png": "UdxU",
	"./2/tab-banner1.png": "5Jps",
	"./3/tab-banner1.png": "ujVE",
	"./4/tab-banner1.png": "XQ6O",
	"./5/tab-banner1.png": "wxmT",
	"./6/tab-banner1.png": "FZ03",
	"./7/tab-banner1.png": "2a2+",
	"./8/tab-banner1.png": "+3Xz"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "4FXf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs ^\.\/.*\/tab\-banner1\.png$
// module id = 4FXf
// module chunks = 1